<div style="font-family: Arial, Helvetica, sans-serif; background:#f3f4f6; padding:20px;">

  <div
    style="max-width:1000px; margin:0 auto; background:#ffffff; border-radius:8px; box-shadow:0 2px 8px rgba(0,0,0,0.08); overflow:hidden;">

    <div style="text-align:center; padding:20px 16px; border-bottom:1px solid #e5e7eb;">
      <div style="font-size:22px; font-weight:bold; color:#111827;">Hanwha Philly Shipyard</div>
      <div style="font-size:16px; margin-top:4px;">
        <span style="color:#f97316; font-weight:600;">Service Request System</span>
        <span style="color:#6b7280;">: Maintenance</span>
      </div>
    </div>

    <div
      style="display:flex; justify-content:space-between; align-items:center; background:#f97316; color:#fff; font-size:14px;">

      <p style="width: 100%; text-align: center;">{{today | date:'fullDate'}}</p>
    </div>

    <div
      style="padding:16px; background:#fef2f2; color:#b91c1c; font-size:14px; text-align:center; border-bottom:1px solid #e5e7eb;">
      <strong>PLEASE NOTE:</strong> Any maintenance issue involving health, safety, or environmental risk must be
      immediately reported to the Safety Department.
    </div>

    <div style="display:flex; gap:20px; padding:20px; flex-wrap:wrap;">

      <div style="flex:1 1 600px;">

        <div style="border:1px solid #e5e7eb; border-radius:6px; overflow:hidden;">

          <div style="background:#0f4c81; color:#fff; padding:10px 14px; font-weight:600;">
            Request Details
          </div>

          <div style="padding:16px; display:grid; gap:14px;" [formGroup]="form">

            <mat-form-field appearance="outline" style="width:100%;">
              <mat-label>Equipment</mat-label>

              <input matInput [formControl]="equipmentSearch" [matAutocomplete]="equipmentAuto">

              <mat-autocomplete #equipmentAuto="matAutocomplete" [displayWith]="displayEquipment" (optionSelected)="
              form.patchValue({
                equipmentMachineId: $event.option.value.id
              })
            ">

                @for (equipment of filteredEquipmentMachines; track equipment.id) {
                <mat-option [value]="equipment">
                  {{ equipment.name }}({{ equipment.id }})
                </mat-option>
                }

              </mat-autocomplete>
            </mat-form-field>


            <mat-form-field appearance="outline" style="width:100%;">
              <mat-label>Location *</mat-label>

              <input matInput [formControl]="locationSearch" [matAutocomplete]="locationAuto">

              <mat-autocomplete #locationAuto="matAutocomplete" [displayWith]="displayLocation" (optionSelected)="
                form.patchValue({
                  locationId: $event.option.value.id
                })
              ">

                @for (location of filteredLocations; track location.id) {
                <mat-option [value]="location">
                  {{ location.name }}
                </mat-option>
                }

              </mat-autocomplete>
            </mat-form-field>

            <mat-form-field appearance="outline" style="width:100%;">
              <mat-label>Cause *</mat-label>

              <mat-select formControlName="maintenanceCauseId">

                @for (cause of filterValues()?.maintenanceCauses ?? []; track cause.id) {
                <mat-option [value]="cause.id">
                  {{ cause.name }}
                </mat-option>
                }

              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" style="width:100%;">
              <mat-label>Sub Cause (Optional)</mat-label>

              <mat-select formControlName="maintenanceSubCauseId">

                <mat-option [value]="null">
                  None
                </mat-option>

                @for (subCause of filterValues() ?.maintenanceSubCauses ?? []; track subCause.id) {
                <mat-option [value]="subCause.id">
                  {{ subCause.name }}
                </mat-option>
                }

              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" style="width:100%;">
              <mat-label>Priority *</mat-label>

              <mat-select formControlName="priority">

                @for (p of filterValues()?.priorities ?? []; track p) {
                <mat-option [value]="p">
                  {{ p }}
                </mat-option>
                }

              </mat-select>
              @if(form.controls.priority.invalid) {
              <mat-error>
                Priority is required
              </mat-error>
              }
            </mat-form-field>

            <div>
              <label style="font-weight:600; display:block; margin-bottom:8px;">
                Is Equipment Operational?
              </label>

              <mat-radio-group formControlName="isOperational">
                <mat-radio-button [value]="true">
                  Yes
                </mat-radio-button>

                <mat-radio-button [value]="false" style="margin-left:16px;">
                  No
                </mat-radio-button>
              </mat-radio-group>
            </div>

            <div>
              <label style="font-weight:600; display:block; margin-bottom:8px;">
                Is Equipment Tagged Out?
              </label>

              <mat-radio-group formControlName="isTaggedOut">
                <mat-radio-button [value]="true">
                  Yes
                </mat-radio-button>

                <mat-radio-button [value]="false" style="margin-left:16px;">
                  No
                </mat-radio-button>
              </mat-radio-group>
            </div>

            <div>
              <label style="font-weight:600; display:block; margin-bottom:8px;">
                Was LOTO Followed?
              </label>

              <mat-radio-group formControlName="isLOTOFollowed">
                <mat-radio-button [value]="true">
                  Yes
                </mat-radio-button>

                <mat-radio-button [value]="false" style="margin-left:16px;">
                  No
                </mat-radio-button>
              </mat-radio-group>
            </div>


            <mat-form-field appearance="outline" style="width:100%;">
              <mat-label>Description of Issue *</mat-label>

              <textarea matInput rows="5" formControlName="description">
              </textarea>
            </mat-form-field>

          </div>
        </div>
        <div>

          <label style="
            font-weight:600;
            display:block;
            margin-bottom:8px;
          ">
            Photos (Optional)
          </label>

          <button mat-stroked-button color="primary" type="button" (click)="fileInput.click()">

            Add Photos

          </button>

          <input #fileInput hidden type="file" multiple accept="image/*" (change)="onFilesSelected($event)" />

        </div>
        @if(imagePreviews.length > 0) {

        <div style="
    margin-top:16px;
    display:flex;
    flex-wrap:wrap;
    gap:12px;
  ">

          @for(image of imagePreviews; track image.file.name; let i = $index) {

          <div style="
      position:relative;
      width:120px;
      height:120px;
    ">

            <img [src]="image.preview" alt="Preview" style="
        width:100%;
        height:100%;
        object-fit:cover;
        border-radius:8px;
        border:1px solid #d1d5db;
      " />

            <button mat-mini-fab color="warn" type="button" (click)="removePhoto(i)" style="
        position:absolute;
        top:-10px;
        right:-10px;
      ">
              ✕
            </button>

          </div>

          }

        </div>

        }

        <div style="margin-top:20px; display:flex; gap:12px;">

          <button mat-raised-button color="primary" type="button" (click)="submit()">

            Submit Request

          </button>

          <button mat-stroked-button color="warn" type="button"
            (click)="form.reset(); imagePreviews = []; selectedFiles = []">

            Clear Form

          </button>

        </div>

      </div>

      <div style="flex:1 1 300px;">
        <div style="border:1px solid #e5e7eb; border-radius:6px; overflow:hidden;">

          <div style="background:#0f4c81; color:#fff; padding:10px 14px; font-weight:600;">
            Instructions
          </div>

          <div style="padding:16px; font-size:14px; color:#374151;">
            <ul style="padding-left:18px; margin:0;">
              <li style="margin-bottom:8px;">Complete all required fields.</li>
              <li style="margin-bottom:8px;">An email will be sent to Maintenance upon submission.</li>
              <li>Status updates will be available after review.</li>
            </ul>
          </div>

        </div>
      </div>

    </div>

  </div>
</div>